import { useCallback, useMemo, useState } from 'react';

export interface CollectionFilterInitialFetchTimingProps {
  /**
   * Define the timing for initial fetch of the filter collection data:
   * - `focus` - on the first user interaction with the filter component
   * @default undefined - on component mount
   */
  initialFetchTiming?: 'focus';
  collection: {
    initialFetch: () => unknown;
  };
}
export function useCollectionFilterInitialFetchTiming(
  props: CollectionFilterInitialFetchTimingProps,
) {
  const { initialFetchTiming, collection } = props;

  useState(() => {
    if (!initialFetchTiming) {
      collection.initialFetch();
    }
  });

  const onFocus = useCallback(() => {
    initialFetchTiming === 'focus' && collection.initialFetch();
  }, [initialFetchTiming]);

  const skipInitialFetch = useMemo(
    () => initialFetchTiming === 'focus',
    [initialFetchTiming],
  );

  return {
    onFocus,
    skipInitialFetch,
  };
}
